(function () {
  function escapeHtml(value) {
    return String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  function toNumber(value, fallback = 0) {
    const n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function round2(value) {
    return Math.round((toNumber(value) + Number.EPSILON) * 100) / 100;
  }

  function fmt(value, decimals) {
    return toNumber(value).toLocaleString("en-GB", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  const ROOM_RULES = {
    offices: { label: "Offices", ach: 4, lsPerPerson: 10, minM2PerPerson: 6 },
    meeting_room: { label: "Meeting room / Board Room", ach: 4, lsPerPerson: 5, minM2PerPerson: 4 },
    entrance_hall: { label: "Entrance Halls - Corridors - Common areas", ach: 1, lsPerPerson: 0.5, minM2PerPerson: 8 },
    toilets: { label: "Toilets", ach: 4, lsPerPerson: 6, minM2PerPerson: 5 },
    staff_canteens: { label: "Staff Canteens", ach: 8, lsPerPerson: 12, minM2PerPerson: 4 },

    classrooms: { label: "Classrooms", ach: 4, lsPerPerson: 8, minM2PerPerson: 4 },
    creche: { label: "Creche", ach: 3, lsPerPerson: 8, minM2PerPerson: 5 },
    assembly_halls: { label: "Assembly Halls", ach: 4, lsPerPerson: 5, minM2PerPerson: 4 },
    staff_rooms: { label: "Staff Canteens / Staff Rooms", ach: 8, lsPerPerson: 12, minM2PerPerson: 5 },
    lecture_theatre: { label: "Lecture Theatre", ach: 4, lsPerPerson: 5, minM2PerPerson: 5 },

    dental: { label: "Dental Surgeries", ach: 10, lsPerPerson: 0, minM2PerPerson: 0 },
    vet: { label: "Veterinary Surgeries / Kennels", ach: 10, lsPerPerson: 0, minM2PerPerson: 0 },
    sterilising: { label: "Sterilising", ach: 15, lsPerPerson: 0, minM2PerPerson: 0 },
    clean_room: { label: "Clean Room / Hygiene rooms", ach: 8, lsPerPerson: 0, minM2PerPerson: 0 },
    isolation: { label: "Isolation / Decontamination", ach: 15, lsPerPerson: 0, minM2PerPerson: 0 },
    laboratories: { label: "Laboratories", ach: 10, lsPerPerson: 0, minM2PerPerson: 0 },
    contaminant_store: { label: "Store - Cleaning or contaminants", ach: 6, lsPerPerson: 0, minM2PerPerson: 0 },
    xray_darkrooms: { label: "X-ray Darkrooms", ach: 10, lsPerPerson: 0, minM2PerPerson: 0 },
    waiting_room: { label: "Waiting Room", ach: 1, lsPerPerson: 10, minM2PerPerson: 2 },

    toilet_block: { label: "Toilet Block", ach: 4, lsPerPerson: 15, minM2PerPerson: 0 },
    changing_main: { label: "Changing rooms - Main Area", ach: 4, lsPerPerson: 10, minM2PerPerson: 0 },
    changing_shower: { label: "Changing rooms with Shower Area", ach: 10, lsPerPerson: 30, minM2PerPerson: 0 },
    gym_light: { label: "Sports Hall / Gym - Light work", ach: 4, lsPerPerson: 15, minM2PerPerson: 5 },
    gym_commercial: { label: "Sports Hall / Gym - Commercial / Dance Studio", ach: 10, lsPerPerson: 20, minM2PerPerson: 5 },
    club_rooms: { label: "Club Rooms", ach: 10, lsPerPerson: 10, minM2PerPerson: 3 },
    warehouse_clean: { label: "Store rooms & Warehouses with no pollutants", ach: 3, lsPerPerson: 30, minM2PerPerson: 0 },
    swimming_pool: { label: "Swimming Pool Domestic with pool cover", ach: 2, lsPerPerson: 0, minM2PerPerson: 0 },

    treatment_room: { label: "Treatment Room", ach: 6, lsPerPerson: 0, minM2PerPerson: 0 },
    nail_parlour: { label: "Nail Parlour", ach: 10, lsPerPerson: 0, minM2PerPerson: 0 },
    hair_salon: { label: "Hairdressing Salons", ach: 10, lsPerPerson: 0, minM2PerPerson: 0 },

    bar: { label: "Bar", ach: 4, lsPerPerson: 12, minM2PerPerson: 0.5 },
    restaurant: { label: "Restaurant - Cafes and Coffee Bars", ach: 6, lsPerPerson: 12, minM2PerPerson: 1 },
    reception: { label: "Reception Area", ach: 1, lsPerPerson: 5, minM2PerPerson: 0 },
    kitchens_domestic: { label: "Kitchens - Domestic", ach: 15, lsPerPerson: 60, minM2PerPerson: 0 },
    guest_house: { label: "Guest house / Hostel", ach: 3, lsPerPerson: 0, minM2PerPerson: 0 },

    laundrette: { label: "Laundrette", ach: 10, lsPerPerson: 12, minM2PerPerson: 0 },
    shops_showrooms: { label: "Shops retail and Showrooms", ach: 4, lsPerPerson: 5, minM2PerPerson: 5 },
    churches: { label: "Churches", ach: 2, lsPerPerson: 5, minM2PerPerson: 0 },
    garage_showrooms: { label: "Garage / garage Showrooms", ach: 4, lsPerPerson: 10, minM2PerPerson: 0 },
    cinemas: { label: "Cinemas and Theatres", ach: 10, lsPerPerson: 0, minM2PerPerson: 0 },
    factories: { label: "Factories & workshops", ach: 8, lsPerPerson: 0, minM2PerPerson: 0 },
    art_studio: { label: "Art studio using paint", ach: 6, lsPerPerson: 0, minM2PerPerson: 0 }
  };

  const COMMERCIAL_MVHR_UNITS = [
  {
    "sku": "D69 - CFHR 500",
    "supplierPartNumber": "D69 - CFHR 500",
    "name": "Dogu CFHR 500 FLAT CF AHU c/w Touch Controller - 350m3/h@200Pa (1297L / 560w ...",
    "brand": "Dogu",
    "model": "CFHR",
    "maxFlowM3h": 350.0,
    "ratedFlowAt100PaM3h": 350.0,
    "recommendedMaxM3h": 262.5,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "200x210mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D74-CLASSMATE 500",
    "supplierPartNumber": "D74-CLASSMATE 500",
    "name": "Dogu CLASSMATE 500 Single Room AHU c/w Touch Controller - 500m3/h (1330L / 82...",
    "brand": "Dogu",
    "model": "Classmate",
    "maxFlowM3h": 500.0,
    "ratedFlowAt100PaM3h": 500.0,
    "recommendedMaxM3h": 375.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": true
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "200mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D69 - CFHR 700",
    "supplierPartNumber": "D69 - CFHR 700",
    "name": "Dogu CFHR 700 FLAT CF AHU c/w Touch Controller - 520m3/h@200Pa (1340L / 580w ...",
    "brand": "Dogu",
    "model": "CFHR",
    "maxFlowM3h": 520.0,
    "ratedFlowAt100PaM3h": 520.0,
    "recommendedMaxM3h": 390.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "200x210mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D73-RTER 1000",
    "supplierPartNumber": "D73-RTER 1000",
    "name": "Dogu RTER 1000 Vertical/Uni Sorption ROTARY AHU c/w Controller - 700m3/h@200P...",
    "brand": "Dogu",
    "model": "RTER",
    "maxFlowM3h": 700.0,
    "ratedFlowAt100PaM3h": 700.0,
    "recommendedMaxM3h": 525.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Vertical",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "300x225mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D72-FHR 1000",
    "supplierPartNumber": "D72-FHR 1000",
    "name": "Dogu FHR 1000 Horizontal CF AHU c/w Controller - 750m3/h@200Pa (1330L / 865w ...",
    "brand": "Dogu",
    "model": "FHR",
    "maxFlowM3h": 750.0,
    "ratedFlowAt100PaM3h": 750.0,
    "recommendedMaxM3h": 562.5,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": false,
      "floorSide": true
    },
    "mountingLabel": "Horizontal",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "450x250mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D69 - CFHR 1000",
    "supplierPartNumber": "D69 - CFHR 1000",
    "name": "Dogu CFHR 1000 FLAT CF AHU c/w Touch Controller - 810m3/h@200Pa (1450L / 840w...",
    "brand": "Dogu",
    "model": "CFHR",
    "maxFlowM3h": 810.0,
    "ratedFlowAt100PaM3h": 810.0,
    "recommendedMaxM3h": 607.5,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "320x210mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D69 - CFHR 1200",
    "supplierPartNumber": "D69 - CFHR 1200",
    "name": "Dogu CFHR 1200 FLAT CF AHU c/w Touch Controller - 940m3/h@200Pa (1540L / 1060...",
    "brand": "Dogu",
    "model": "CFHR",
    "maxFlowM3h": 940.0,
    "ratedFlowAt100PaM3h": 940.0,
    "recommendedMaxM3h": 705.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "400x210mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D74-CLASSMATE 1000",
    "supplierPartNumber": "D74-CLASSMATE 1000",
    "name": "Dogu CLASSMATE 1000 Single Room AHU c/w Touch Controller - 1000m3/h@200Pa (16...",
    "brand": "Dogu",
    "model": "Classmate",
    "maxFlowM3h": 1000.0,
    "ratedFlowAt100PaM3h": 1000.0,
    "recommendedMaxM3h": 750.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": true
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "250mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D69 - CFHR 1600",
    "supplierPartNumber": "D69 - CFHR 1600",
    "name": "Dogu CFHR 1600 FLAT CF AHU c/w Touch Controller - 1400m3/h@200Pa (1790L / 132...",
    "brand": "Dogu",
    "model": "CFHR",
    "maxFlowM3h": 1400.0,
    "ratedFlowAt100PaM3h": 1400.0,
    "recommendedMaxM3h": 1050.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "530x210mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D72-FHR 1600",
    "supplierPartNumber": "D72-FHR 1600",
    "name": "Dogu FHR 1600 Horizontal CF AHU c/w Controller - 1400m3/h@200Pa (1555L / 865w...",
    "brand": "Dogu",
    "model": "FHR",
    "maxFlowM3h": 1400.0,
    "ratedFlowAt100PaM3h": 1400.0,
    "recommendedMaxM3h": 1050.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": false,
      "floorSide": true
    },
    "mountingLabel": "Horizontal",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "550x300mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D74-CLASSMATE 1500",
    "supplierPartNumber": "D74-CLASSMATE 1500",
    "name": "Dogu CLASSMATE 1500 Single Room AHU c/w Touch Controller - 1500m3/h@200Pa (20...",
    "brand": "Dogu",
    "model": "Classmate",
    "maxFlowM3h": 1500.0,
    "ratedFlowAt100PaM3h": 1500.0,
    "recommendedMaxM3h": 1125.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": true
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "300mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D73-RTER 1800",
    "supplierPartNumber": "D73-RTER 1800",
    "name": "Dogu RTER 1800 Vertical/Uni Sorption ROTARY AHU c/w Controller - 1500m3/h@200...",
    "brand": "Dogu",
    "model": "RTER",
    "maxFlowM3h": 1500.0,
    "ratedFlowAt100PaM3h": 1500.0,
    "recommendedMaxM3h": 1125.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Vertical",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "300x250mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D69 - CFHR 2500",
    "supplierPartNumber": "D69 - CFHR 2500",
    "name": "Dogu CFHR 2500 FLAT CF AHU c/w Touch Controller - 2000m3/h@200Pa (1890L / 165...",
    "brand": "Dogu",
    "model": "CFHR",
    "maxFlowM3h": 2000.0,
    "ratedFlowAt100PaM3h": 2000.0,
    "recommendedMaxM3h": 1500.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "700x210mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D72-FHR 2500",
    "supplierPartNumber": "D72-FHR 2500",
    "name": "Dogu FHR 2500 Horizontal CF AHU c/w Controller - 2160m3/h@200Pa (2060L / 895w...",
    "brand": "Dogu",
    "model": "FHR",
    "maxFlowM3h": 2160.0,
    "ratedFlowAt100PaM3h": 2160.0,
    "recommendedMaxM3h": 1620.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": false,
      "floorSide": true
    },
    "mountingLabel": "Horizontal",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "550x350mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D69 - CFHR 2800",
    "supplierPartNumber": "D69 - CFHR 2800",
    "name": "Dogu CFHR 2800 FLAT CF AHU c/w Touch Controller - 2200m3/h@200Pa (1890L / 195...",
    "brand": "Dogu",
    "model": "CFHR",
    "maxFlowM3h": 2200.0,
    "ratedFlowAt100PaM3h": 2200.0,
    "recommendedMaxM3h": 1650.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "830x210mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D73-RTER 2500",
    "supplierPartNumber": "D73-RTER 2500",
    "name": "Dogu RTER 2500 Vertical/Uni Sorption ROTARY AHU c/w Controller - 2220m3/h@200...",
    "brand": "Dogu",
    "model": "RTER",
    "maxFlowM3h": 2220.0,
    "ratedFlowAt100PaM3h": 2220.0,
    "recommendedMaxM3h": 1665.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Vertical",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "300x310mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D69 - CFHR 3300",
    "supplierPartNumber": "D69 - CFHR 3300",
    "name": "Dogu CFHR 3300 FLAT CF AHU c/w Touch Controller - 2700m3/h@200Pa (1990L / 195...",
    "brand": "Dogu",
    "model": "CFHR",
    "maxFlowM3h": 2700.0,
    "ratedFlowAt100PaM3h": 2700.0,
    "recommendedMaxM3h": 2025.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "800x310mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D73-RTER 3500",
    "supplierPartNumber": "D73-RTER 3500",
    "name": "Dogu RTER 3500 Vertical/Uni Sorption ROTARY AHU c/w Controller - 2820m3/h@200...",
    "brand": "Dogu",
    "model": "RTER",
    "maxFlowM3h": 2820.0,
    "ratedFlowAt100PaM3h": 2820.0,
    "recommendedMaxM3h": 2115.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Vertical",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "315x400mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D69 - CFHR 4000",
    "supplierPartNumber": "D69 - CFHR 4000",
    "name": "Dogu CFHR 4000 FLAT CF AHU c/w Touch Controller - 3400m3/h@200Pa (2130L / 200...",
    "brand": "Dogu",
    "model": "CFHR",
    "maxFlowM3h": 3400.0,
    "ratedFlowAt100PaM3h": 3400.0,
    "recommendedMaxM3h": 2550.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "850x410mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D72-FHR 4000",
    "supplierPartNumber": "D72-FHR 4000",
    "name": "Dogu FHR 4000 Horizontal CF AHU c/w Controller - 3420m3/h@200Pa (2810L / 950w...",
    "brand": "Dogu",
    "model": "FHR",
    "maxFlowM3h": 3420.0,
    "ratedFlowAt100PaM3h": 3420.0,
    "recommendedMaxM3h": 2565.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": false,
      "floorSide": true
    },
    "mountingLabel": "Horizontal",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "600x450mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D73-RTER 5000",
    "supplierPartNumber": "D73-RTER 5000",
    "name": "Dogu RTER 5000 Vertical/Uni Sorption ROTARY AHU c/w Controller - 4300m3/h@200...",
    "brand": "Dogu",
    "model": "RTER",
    "maxFlowM3h": 4300.0,
    "ratedFlowAt100PaM3h": 4300.0,
    "recommendedMaxM3h": 3225.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Vertical",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "400x400mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D72-FHR 6000",
    "supplierPartNumber": "D72-FHR 6000",
    "name": "Dogu FHR 6000 Horizontal CF AHU c/w Controller - 5400m3/h@200Pa (3155L / 1230...",
    "brand": "Dogu",
    "model": "FHR",
    "maxFlowM3h": 5400.0,
    "ratedFlowAt100PaM3h": 5400.0,
    "recommendedMaxM3h": 4050.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": false,
      "floorSide": true
    },
    "mountingLabel": "Horizontal",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "950x500mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D73-RTER 7000",
    "supplierPartNumber": "D73-RTER 7000",
    "name": "Dogu RTER 7000 Vertical/Uni Sorption ROTARY AHU c/w Controller - 5700m3/h@200...",
    "brand": "Dogu",
    "model": "RTER",
    "maxFlowM3h": 5700.0,
    "ratedFlowAt100PaM3h": 5700.0,
    "recommendedMaxM3h": 4275.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Vertical",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "500x460mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D72-FHR 8500",
    "supplierPartNumber": "D72-FHR 8500",
    "name": "Dogu FHR 8500 Horizontal CF AHU c/w Controller - 7950m3/h@200Pa (3165L / 1790...",
    "brand": "Dogu",
    "model": "FHR",
    "maxFlowM3h": 7950.0,
    "ratedFlowAt100PaM3h": 7950.0,
    "recommendedMaxM3h": 5962.5,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": false,
      "floorSide": true
    },
    "mountingLabel": "Horizontal",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "1200x500mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D73-RTER 9000",
    "supplierPartNumber": "D73-RTER 9000",
    "name": "Dogu RTER 9000 Vertical/Uni Sorption ROTARY AHU c/w Controller - 8580m3/h@200...",
    "brand": "Dogu",
    "model": "RTER",
    "maxFlowM3h": 8580.0,
    "ratedFlowAt100PaM3h": 8580.0,
    "recommendedMaxM3h": 6435.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Vertical",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "600x530mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D72-FHR 11000",
    "supplierPartNumber": "D72-FHR 11000",
    "name": "Dogu FHR 11000 Horizontal CF AHU c/w Controller - 9800m3/h@200Pa (3165L / 207...",
    "brand": "Dogu",
    "model": "FHR",
    "maxFlowM3h": 9800.0,
    "ratedFlowAt100PaM3h": 9800.0,
    "recommendedMaxM3h": 7350.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": false,
      "floorSide": true
    },
    "mountingLabel": "Horizontal",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "1450x600mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D73-RTER 11000",
    "supplierPartNumber": "D73-RTER 11000",
    "name": "Dogu RTER 11000 Vertical/Uni Sorption ROTARY AHU c/w Controller - 10800m3/h@2...",
    "brand": "Dogu",
    "model": "RTER",
    "maxFlowM3h": 10800.0,
    "ratedFlowAt100PaM3h": 10800.0,
    "recommendedMaxM3h": 8100.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Vertical",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "600x595mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D72-FHR 14000",
    "supplierPartNumber": "D72-FHR 14000",
    "name": "Dogu FHR 14000 Horizontal CF AHU c/w Controller - 13100m3/h@200Pa (4280L / 17...",
    "brand": "Dogu",
    "model": "FHR",
    "maxFlowM3h": 13100.0,
    "ratedFlowAt100PaM3h": 13100.0,
    "recommendedMaxM3h": 9825.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": false,
      "floorSide": true
    },
    "mountingLabel": "Horizontal",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "1500x650mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D73-RTER 14000",
    "supplierPartNumber": "D73-RTER 14000",
    "name": "Dogu RTER 14000 Vertical/Uni Sorption ROTARY AHU c/w Controller - 13600m3/h@2...",
    "brand": "Dogu",
    "model": "RTER",
    "maxFlowM3h": 13600.0,
    "ratedFlowAt100PaM3h": 13600.0,
    "recommendedMaxM3h": 10200.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Vertical",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "700x660mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D72-FHR 17000",
    "supplierPartNumber": "D72-FHR 17000",
    "name": "Dogu FHR 17000 Horizontal CF AHU c/w Controller - 15800m3/h@200Pa (4885L / 17...",
    "brand": "Dogu",
    "model": "FHR",
    "maxFlowM3h": 15800.0,
    "ratedFlowAt100PaM3h": 15800.0,
    "recommendedMaxM3h": 11850.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": false,
      "floorSide": true
    },
    "mountingLabel": "Horizontal",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "1500x650mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "D73-RTER 20000",
    "supplierPartNumber": "D73-RTER 20000",
    "name": "Dogu RTER 20000 Vertical/Uni Sorption ROTARY AHU c/w Controller - 18700m3/h@2...",
    "brand": "Dogu",
    "model": "RTER",
    "maxFlowM3h": 18700.0,
    "ratedFlowAt100PaM3h": 18700.0,
    "recommendedMaxM3h": 14025.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Vertical",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "900x800mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "LGH160RVXT3-E",
    "supplierPartNumber": "LGH160RVXT3-E",
    "name": "Mitsubishi Lossnay LGH160 RVXT3-E Commercial MVHR (250x650mm spigot) - 3 Ph S...",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 1600.0,
    "ratedFlowAt100PaM3h": 1600.0,
    "recommendedMaxM3h": 1200.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "2 x (250x650mm) & 2 x (465x220mm)",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "LGH200RVXT3-E",
    "supplierPartNumber": "LGH200RVXT3-E",
    "name": "Mitsubishi Lossnay LGH200 RVXT3-E Commercial MVHR (250x650mm spigot) - 3 Ph S...",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 2000.0,
    "ratedFlowAt100PaM3h": 2000.0,
    "recommendedMaxM3h": 1500.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "2 x (250x650mm) & 2 x (465x220mm)",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "LGH250RVXT3-E",
    "supplierPartNumber": "LGH250RVXT3-E",
    "name": "Mitsubishi Lossnay LGH250 RVXT3-E Commercial MVHR (250x650mm spigot) - 3 Ph S...",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 2500.0,
    "ratedFlowAt100PaM3h": 2500.0,
    "recommendedMaxM3h": 1875.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "2 x (250x650mm) & 2 x (465x220mm)",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "LGH15RVX3-E",
    "supplierPartNumber": "LGH15RVX3-E",
    "name": "Mitsubishi Lossnay LGH-15RVX3-E Commercial MVHR (100mm Spigot)",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 150.0,
    "ratedFlowAt100PaM3h": 150.0,
    "recommendedMaxM3h": 112.5,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "100mm",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "LGH25RVX3-E",
    "supplierPartNumber": "LGH25RVX3-E",
    "name": "Mitsubishi Lossnay LGH-25RVX3-E Commercial MVHR (150mm Spigot)",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 250.0,
    "ratedFlowAt100PaM3h": 250.0,
    "recommendedMaxM3h": 187.5,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "150mm",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "LGH35RVX3-E",
    "supplierPartNumber": "LGH35RVX3-E",
    "name": "Mitsubishi Lossnay LGH-35RVX3-E Commercial MVHR (150mm Spigot)",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 350.0,
    "ratedFlowAt100PaM3h": 350.0,
    "recommendedMaxM3h": 262.5,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "150mm",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "LGH50RVX3-E",
    "supplierPartNumber": "LGH50RVX3-E",
    "name": "Mitsubishi Lossnay LGH-50RVX3-E Commercial MVHR (200mm Spigot)",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 500.0,
    "ratedFlowAt100PaM3h": 500.0,
    "recommendedMaxM3h": 375.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "200mm",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "LGH65RVX3-E",
    "supplierPartNumber": "LGH65RVX3-E",
    "name": "Mitsubishi Lossnay LGH-65RVX3-E Commercial MVHR (200mm Spigot)",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 650.0,
    "ratedFlowAt100PaM3h": 650.0,
    "recommendedMaxM3h": 487.5,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "200mm",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "LGH80RVX3-E",
    "supplierPartNumber": "LGH80RVX3-E",
    "name": "Mitsubishi Lossnay LGH-80RVX3-E Commercial MVHR (250mm Spigot)",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 800.0,
    "ratedFlowAt100PaM3h": 800.0,
    "recommendedMaxM3h": 600.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "250mm",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "LGH100RVX3-E",
    "supplierPartNumber": "LGH100RVX3-E",
    "name": "Mitsubishi Lossnay LGH-100RVX3-E Commercial MVHR (250mm Spigot)",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 1000.0,
    "ratedFlowAt100PaM3h": 1000.0,
    "recommendedMaxM3h": 750.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "250mm",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "LGH160RVX3-E",
    "supplierPartNumber": "LGH160RVX3-E",
    "name": "Mitsubishi Lossnay LGH-160RVX3-E Commercial MVHR (250mm Spigots)",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 1600.0,
    "ratedFlowAt100PaM3h": 1600.0,
    "recommendedMaxM3h": 1200.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "250mm",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "LGH200RVX3-E",
    "supplierPartNumber": "LGH200RVX3-E",
    "name": "Mitsubishi Lossnay LGH-200RVX3-E Commercial MVHR (250mm Spigots)",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 2000.0,
    "ratedFlowAt100PaM3h": 2000.0,
    "recommendedMaxM3h": 1500.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "250mm",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "HR06",
    "supplierPartNumber": "HR06",
    "name": "Vent Axia APEX HR06 - FLAT Commercial MVHR 792m3/h@150Pa",
    "brand": "Vent Axia",
    "model": "Apex HR",
    "maxFlowM3h": 792.0,
    "ratedFlowAt100PaM3h": 792.0,
    "recommendedMaxM3h": 594.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "400x200mm",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "HR10",
    "supplierPartNumber": "HR10",
    "name": "Vent Axia APEX HR10 - FLAT Commercial MVHR 936m3/h@150Pa",
    "brand": "Vent Axia",
    "model": "Apex HR",
    "maxFlowM3h": 936.0,
    "ratedFlowAt100PaM3h": 936.0,
    "recommendedMaxM3h": 702.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "400x300mm",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "HR15",
    "supplierPartNumber": "HR15",
    "name": "Vent Axia APEX HR15 - FLAT Commercial MVHR 1800m3/h@150Pa",
    "brand": "Vent Axia",
    "model": "Apex HR",
    "maxFlowM3h": 1800.0,
    "ratedFlowAt100PaM3h": 1800.0,
    "recommendedMaxM3h": 1350.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "400x300mm",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "HR21",
    "supplierPartNumber": "HR21",
    "name": "Vent Axia APEX HR21 - FLAT Commercial MVHR 2376m3/h@150Pa",
    "brand": "Vent Axia",
    "model": "Apex HR",
    "maxFlowM3h": 2376.0,
    "ratedFlowAt100PaM3h": 2376.0,
    "recommendedMaxM3h": 1782.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "500x400mm",
    "controlIncluded": false,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF026170",
    "supplierPartNumber": "CDF026170",
    "name": "Zehnder-Caladair CARMA 9008 L First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "CARMA",
    "maxFlowM3h": 900.0,
    "ratedFlowAt100PaM3h": 900.0,
    "recommendedMaxM3h": 675.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "315mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF026246",
    "supplierPartNumber": "CDF026246",
    "name": "Zehnder-Caladair CARMA 9010 L First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "CARMA",
    "maxFlowM3h": 1400.0,
    "ratedFlowAt100PaM3h": 1400.0,
    "recommendedMaxM3h": 1050.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "315mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF026370",
    "supplierPartNumber": "CDF026370",
    "name": "Zehnder-Caladair CARMA 9016 L First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "CARMA",
    "maxFlowM3h": 1800.0,
    "ratedFlowAt100PaM3h": 1800.0,
    "recommendedMaxM3h": 1350.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "400mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF026514",
    "supplierPartNumber": "CDF026514",
    "name": "Zehnder-Caladair CARMA 9023 L First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "CARMA",
    "maxFlowM3h": 2400.0,
    "ratedFlowAt100PaM3h": 2400.0,
    "recommendedMaxM3h": 1800.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "450mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF026658",
    "supplierPartNumber": "CDF026658",
    "name": "Zehnder-Caladair CARMA 9035 L First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "CARMA",
    "maxFlowM3h": 4500.0,
    "ratedFlowAt100PaM3h": 4500.0,
    "recommendedMaxM3h": 3375.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "500mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF026822",
    "supplierPartNumber": "CDF026822",
    "name": "Zehnder-Caladair CARMA 9048 W First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "CARMA",
    "maxFlowM3h": 6000.0,
    "ratedFlowAt100PaM3h": 6000.0,
    "recommendedMaxM3h": 4500.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "630mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF026904",
    "supplierPartNumber": "CDF026904",
    "name": "Zehnder-Caladair CARMA 9070 D First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "CARMA",
    "maxFlowM3h": 8000.0,
    "ratedFlowAt100PaM3h": 8000.0,
    "recommendedMaxM3h": 6000.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "1100x500mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF024151",
    "supplierPartNumber": "CDF024151",
    "name": "Zehnder-Caladair FREETIME 2000 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "FREETIME",
    "maxFlowM3h": 2200.0,
    "ratedFlowAt100PaM3h": 2200.0,
    "recommendedMaxM3h": 1650.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "355mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF024152",
    "supplierPartNumber": "CDF024152",
    "name": "Zehnder-Caladair FREETIME 2700 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "FREETIME",
    "maxFlowM3h": 3400.0,
    "ratedFlowAt100PaM3h": 3400.0,
    "recommendedMaxM3h": 2550.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "400mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF025302",
    "supplierPartNumber": "CDF025302",
    "name": "Zehnder-Caladair HEXAMOTION 05 D FIRST ECO c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "HEXAMOTION",
    "maxFlowM3h": 650.0,
    "ratedFlowAt100PaM3h": 650.0,
    "recommendedMaxM3h": 487.5,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "200mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF025396",
    "supplierPartNumber": "CDF025396",
    "name": "Zehnder-Caladair HEXAMOTION 20 D FIRST ECO c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "HEXAMOTION",
    "maxFlowM3h": 2200.0,
    "ratedFlowAt100PaM3h": 2200.0,
    "recommendedMaxM3h": 1650.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "400mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "ZCDF046905",
    "supplierPartNumber": "CDF046905",
    "name": "Zehnder-Caladair EVERSKY 500 First Diva c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "EVERSKY",
    "maxFlowM3h": 620.0,
    "ratedFlowAt100PaM3h": 620.0,
    "recommendedMaxM3h": 465.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "250mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF024143",
    "supplierPartNumber": "CDF024143",
    "name": "Zehnder-Caladair FREETIME 500 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "FREETIME",
    "maxFlowM3h": 650.0,
    "ratedFlowAt100PaM3h": 650.0,
    "recommendedMaxM3h": 487.5,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "200mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF022976",
    "supplierPartNumber": "CDF022976",
    "name": "Zehnder-Caladair NEOTIME 600 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "NEOTIME",
    "maxFlowM3h": 600.0,
    "ratedFlowAt100PaM3h": 600.0,
    "recommendedMaxM3h": 450.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "250mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "ZCDF047510",
    "supplierPartNumber": "CDF047510",
    "name": "Zehnder-Caladair FLATPOWER 600 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "FLATPOWER",
    "maxFlowM3h": 600.0,
    "ratedFlowAt100PaM3h": 600.0,
    "recommendedMaxM3h": 450.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "250mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF028656",
    "supplierPartNumber": "CDF028656",
    "name": "Zehnder-Caladair SILVERTOP 06 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "SILVERTOP",
    "maxFlowM3h": 700.0,
    "ratedFlowAt100PaM3h": 700.0,
    "recommendedMaxM3h": 525.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "200mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "ZCDF046906",
    "supplierPartNumber": "CDF046906",
    "name": "Zehnder-Caladair EVERSKY 750 First Diva c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "EVERSKY",
    "maxFlowM3h": 850.0,
    "ratedFlowAt100PaM3h": 850.0,
    "recommendedMaxM3h": 637.5,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "315mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF028675",
    "supplierPartNumber": "CDF028675",
    "name": "Zehnder-Caladair SILVERTOP 08 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "SILVERTOP",
    "maxFlowM3h": 900.0,
    "ratedFlowAt100PaM3h": 900.0,
    "recommendedMaxM3h": 675.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "250mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF024149",
    "supplierPartNumber": "CDF024149",
    "name": "Zehnder-Caladair FREETIME 800 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "FREETIME",
    "maxFlowM3h": 900.0,
    "ratedFlowAt100PaM3h": 900.0,
    "recommendedMaxM3h": 675.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "250mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF025328",
    "supplierPartNumber": "CDF025328",
    "name": "Zehnder-Caladair HEXAMOTION 08 D FIRST ECO c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "HEXAMOTION",
    "maxFlowM3h": 900.0,
    "ratedFlowAt100PaM3h": 900.0,
    "recommendedMaxM3h": 675.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "250mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF023092",
    "supplierPartNumber": "CDF023092",
    "name": "Zehnder-Caladair NEOTIME 900 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "NEOTIME",
    "maxFlowM3h": 900.0,
    "ratedFlowAt100PaM3h": 900.0,
    "recommendedMaxM3h": 675.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "315mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "ZCDF047543",
    "supplierPartNumber": "CDF047543",
    "name": "Zehnder-Caladair FLATPOWER 900 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "FLATPOWER",
    "maxFlowM3h": 900.0,
    "ratedFlowAt100PaM3h": 900.0,
    "recommendedMaxM3h": 675.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "315mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "ZCDF046907",
    "supplierPartNumber": "CDF046907",
    "name": "Zehnder-Caladair EVERSKY 900 First Diva c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "EVERSKY",
    "maxFlowM3h": 1060.0,
    "ratedFlowAt100PaM3h": 1060.0,
    "recommendedMaxM3h": 795.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "315mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "ZCDF046908",
    "supplierPartNumber": "CDF046908",
    "name": "Zehnder-Caladair EVERSKY 1100 First Diva c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "EVERSKY",
    "maxFlowM3h": 1320.0,
    "ratedFlowAt100PaM3h": 1320.0,
    "recommendedMaxM3h": 990.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "315mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF023169",
    "supplierPartNumber": "CDF023169",
    "name": "Zehnder-Caladair NEOTIME 1300 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "NEOTIME",
    "maxFlowM3h": 1400.0,
    "ratedFlowAt100PaM3h": 1400.0,
    "recommendedMaxM3h": 1050.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "355mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "ZCDF047576",
    "supplierPartNumber": "CDF047576",
    "name": "Zehnder-Caladair FLATPOWER 1300 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "FLATPOWER",
    "maxFlowM3h": 1400.0,
    "ratedFlowAt100PaM3h": 1400.0,
    "recommendedMaxM3h": 1050.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "355mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF028694",
    "supplierPartNumber": "CDF028694",
    "name": "Zehnder-Caladair SILVERTOP 15 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "SILVERTOP",
    "maxFlowM3h": 1700.0,
    "ratedFlowAt100PaM3h": 1700.0,
    "recommendedMaxM3h": 1275.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "315mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF024150",
    "supplierPartNumber": "CDF024150",
    "name": "Zehnder-Caladair FREETIME 1500 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "FREETIME",
    "maxFlowM3h": 1700.0,
    "ratedFlowAt100PaM3h": 1700.0,
    "recommendedMaxM3h": 1275.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "315mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF025354",
    "supplierPartNumber": "CDF025354",
    "name": "Zehnder-Caladair HEXAMOTION 15 D FIRST ECO c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "HEXAMOTION",
    "maxFlowM3h": 1700.0,
    "ratedFlowAt100PaM3h": 1700.0,
    "recommendedMaxM3h": 1275.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "355mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF023198",
    "supplierPartNumber": "CDF023198",
    "name": "Zehnder-Caladair NEOTIME 1800 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "NEOTIME",
    "maxFlowM3h": 2000.0,
    "ratedFlowAt100PaM3h": 2000.0,
    "recommendedMaxM3h": 1500.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "400mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "ZCDF047609",
    "supplierPartNumber": "CDF047609",
    "name": "Zehnder-Caladair FLATPOWER 1800 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "FLATPOWER",
    "maxFlowM3h": 2000.0,
    "ratedFlowAt100PaM3h": 2000.0,
    "recommendedMaxM3h": 1500.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "400mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF028725",
    "supplierPartNumber": "CDF028725",
    "name": "Zehnder-Caladair SILVERTOP 23 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "SILVERTOP",
    "maxFlowM3h": 2350.0,
    "ratedFlowAt100PaM3h": 2350.0,
    "recommendedMaxM3h": 1762.5,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "400mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF023217",
    "supplierPartNumber": "CDF023217",
    "name": "Zehnder-Caladair NEOTIME 2500 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "NEOTIME",
    "maxFlowM3h": 2500.0,
    "ratedFlowAt100PaM3h": 2500.0,
    "recommendedMaxM3h": 1875.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "400mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "ZCDF047642",
    "supplierPartNumber": "CDF047642",
    "name": "Zehnder-Caladair FLATPOWER 2500 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "FLATPOWER",
    "maxFlowM3h": 2500.0,
    "ratedFlowAt100PaM3h": 2500.0,
    "recommendedMaxM3h": 1875.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "400mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF025438",
    "supplierPartNumber": "CDF025438",
    "name": "Zehnder-Caladair HEXAMOTION 27 D FIRST ECO c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "HEXAMOTION",
    "maxFlowM3h": 3400.0,
    "ratedFlowAt100PaM3h": 3400.0,
    "recommendedMaxM3h": 2550.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "450mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF028756",
    "supplierPartNumber": "CDF028756",
    "name": "Zehnder-Caladair SILVERTOP 35 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "SILVERTOP",
    "maxFlowM3h": 3700.0,
    "ratedFlowAt100PaM3h": 3700.0,
    "recommendedMaxM3h": 2775.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "450mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF024153",
    "supplierPartNumber": "CDF024153",
    "name": "Zehnder-Caladair FREETIME 3500 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "FREETIME",
    "maxFlowM3h": 3800.0,
    "ratedFlowAt100PaM3h": 3800.0,
    "recommendedMaxM3h": 2850.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "450mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF025480",
    "supplierPartNumber": "CDF025480",
    "name": "Zehnder-Caladair HEXAMOTION 35 D FIRST ECO c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "HEXAMOTION",
    "maxFlowM3h": 3800.0,
    "ratedFlowAt100PaM3h": 3800.0,
    "recommendedMaxM3h": 2850.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "500mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF025522",
    "supplierPartNumber": "CDF025522",
    "name": "Zehnder-Caladair HEXAMOTION 45 D FIRST ECO c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "HEXAMOTION",
    "maxFlowM3h": 5700.0,
    "ratedFlowAt100PaM3h": 5700.0,
    "recommendedMaxM3h": 4275.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "630mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF028787",
    "supplierPartNumber": "CDF028787",
    "name": "Zehnder-Caladair SILVERTOP 52 First Eco c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "SILVERTOP",
    "maxFlowM3h": 5400.0,
    "ratedFlowAt100PaM3h": 5400.0,
    "recommendedMaxM3h": 4050.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "960x405mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF025564",
    "supplierPartNumber": "CDF025564",
    "name": "Zehnder-Caladair HEXAMOTION 60 D FIRST ECO c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "HEXAMOTION",
    "maxFlowM3h": 6800.0,
    "ratedFlowAt100PaM3h": 6800.0,
    "recommendedMaxM3h": 5100.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "630mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF025606",
    "supplierPartNumber": "CDF025606",
    "name": "Zehnder-Caladair HEXAMOTION 80 D FIRST ECO c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "HEXAMOTION",
    "maxFlowM3h": 8800.0,
    "ratedFlowAt100PaM3h": 8800.0,
    "recommendedMaxM3h": 6600.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "1100x606mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF019434",
    "supplierPartNumber": "CDF019434",
    "name": "Zehnder-Caladair EXAECO 10 D c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "EXAECO",
    "maxFlowM3h": 11000.0,
    "ratedFlowAt100PaM3h": 11000.0,
    "recommendedMaxM3h": 8250.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "1110x706mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF019554",
    "supplierPartNumber": "CDF019554",
    "name": "Zehnder-Caladair EXAECO 13 D c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "EXAECO",
    "maxFlowM3h": 14000.0,
    "ratedFlowAt100PaM3h": 14000.0,
    "recommendedMaxM3h": 10500.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "1310x806mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF019616",
    "supplierPartNumber": "CDF019616",
    "name": "Zehnder-Caladair EXAECO 17 D c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "EXAECO",
    "maxFlowM3h": 18000.0,
    "ratedFlowAt100PaM3h": 18000.0,
    "recommendedMaxM3h": 13500.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "1580x806mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "KCDF019806",
    "supplierPartNumber": "CDF019806",
    "name": "Zehnder-Caladair EXAECO 22 D c/w Mounted Control Panel",
    "brand": "Zehnder-Caladair",
    "model": "EXAECO",
    "maxFlowM3h": 24000.0,
    "ratedFlowAt100PaM3h": 24000.0,
    "recommendedMaxM3h": 18000.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": false,
      "floorTop": true,
      "floorSide": false
    },
    "mountingLabel": "Floor",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": false,
      "rotaryWheel": true
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "3 Phase",
    "spigot": "1770x906mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "LGH-50RVS-E",
    "supplierPartNumber": "LGH-50RVS-E",
    "name": "Mitsubishi LGH-50RVS-E -With PVC core (200mm Spigot)",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 500.0,
    "ratedFlowAt100PaM3h": 500.0,
    "recommendedMaxM3h": 375.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "200mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "LGH-80RVS-E",
    "supplierPartNumber": "LGH-80RVS-E",
    "name": "Mitsubishi LGH-80RVS-E -With PVC core (250mm Spigot)",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 800.0,
    "ratedFlowAt100PaM3h": 800.0,
    "recommendedMaxM3h": 600.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "250mm",
    "controlIncluded": true,
    "shopifyHandle": null
  },
  {
    "sku": "LGH-100RVS-E",
    "supplierPartNumber": "LGH-100RVS-E",
    "name": "Mitsubishi LGH-100RVS-E -With PVC core (250mm Spigot)",
    "brand": "Mitsubishi",
    "model": "Lossnay",
    "maxFlowM3h": 1000.0,
    "ratedFlowAt100PaM3h": 1000.0,
    "recommendedMaxM3h": 750.0,
    "heatRecoveryPct": null,
    "location": {
      "indoor": true,
      "outdoor": false,
      "decentralised": false
    },
    "mounting": {
      "ceiling": true,
      "floorTop": false,
      "floorSide": false
    },
    "mountingLabel": "Ceiling",
    "heatExchanger": {
      "counterflowWax": false,
      "counterflowPvcAlu": true,
      "rotaryWheel": false
    },
    "heaterOptions": {
      "electricPreHeater": false,
      "electricPostHeater": false,
      "waterPostHeater": false
    },
    "heaterLabel": "None",
    "heaterKw": 0.0,
    "phase": "1 Phase",
    "spigot": "250mm",
    "controlIncluded": true,
    "shopifyHandle": null
  }
];

const MITSUBISHI_ACCESSORIES = [
  {
    sku: "PZ-62DR-E",
    name: "Mitsubishi Lossnay LGH Digital controller PZ-62DR-E for LGH Commercial MVHR",
    brand: "Mitsubishi"
  },
  {
    sku: "PZ-70CSD-E",
    name: "Lossnay RVX3 Duct mounted plug and play CO2 Sensor",
    brand: "Mitsubishi"
  },
  {
    sku: "PZ-70CSW-E",
    name: "Lossnay RVX3 Wall mounted plug and play CO2 sensor with traffic light signals",
    brand: "Mitsubishi"
  }
];


function getCommercialUnitSearchText(unit) {
  return [unit?.sku, unit?.supplierPartNumber, unit?.name, unit?.brand, unit?.model]
    .filter(Boolean)
    .join(" ")
    .toUpperCase();
}

function isMitsubishiRvsUnit(unit) {
  const text = getCommercialUnitSearchText(unit);
  return text.includes("MITSUBISHI") && (text.includes("RVS-E") || text.includes("RVS"));
}

function isOutdoorRainProtectedRange(unit) {
  const text = getCommercialUnitSearchText(unit);
  return text.includes("CARMA") || text.includes("HEXAMOTION") || text.includes("EXAECO");
}

function enrichCommercialUnit(unit) {
  const isMitsu = isMitsubishiUnit(unit);

  const locationType =
    unit.location?.decentralised ? "single_room_visible" :
    isOutdoorRainProtectedRange(unit) ? "outdoor_rain_protected" :
    unit.location?.outdoor ? "outdoor_rain_protected" :
    "indoor_unseen";

  const orientationType =
    unit.mounting?.ceiling ? "ceiling" :
    unit.mounting?.floorTop ? "floor_top" :
    unit.mounting?.floorSide ? "floor_side" :
    "";

  const outdoorRainHoodRequired = isOutdoorRainProtectedRange(unit);

  const heatExchangerType =
    unit.heatExchanger?.rotaryWheel ? "rotary" :
    (unit.heatExchanger?.counterflowWax || unit.heatExchanger?.counterflowPvcAlu) ? "counterflow" :
    "";

  const highMoistureSuitable = isMitsubishiRvsUnit(unit);

  const controlOptions = isMitsu
    ? {
        normal: true,
        co2: true,
        constantPressure: false
      }
    : {
        normal: true,
        co2: false,
        constantPressure: false
      };

  return {
    ...unit,
    locationType,
    orientationType,
    heatExchangerType,
    highMoistureSuitable,
    outdoorRainHoodRequired,
    controlOptions
  };
}

function buildCapabilities(unit) {
  const model = String(unit?.model || "").toLowerCase();
  const name = String(unit?.name || "").toLowerCase();

  const airflowType = unit.heatExchanger?.rotaryWheel
    ? "rotary"
    : (unit.heatExchanger?.counterflowWax || unit.heatExchanger?.counterflowPvcAlu)
      ? "counterflow"
      : "";

  const isZehnder = isZehnderUnit(unit);
  const isMitsu = isMitsubishiUnit(unit);
  const isEversky = model.includes("eversky") || name.includes("eversky");

  if (isMitsu) {
  return {
    controllers: {},
    packages: {},
    heaters: {
      electricPreHeater: !!unit.heaterOptions?.electricPreHeater,
      electricPostHeater: !!unit.heaterOptions?.electricPostHeater,
      waterPostHeater: !!unit.heaterOptions?.waterPostHeater
    },
    controls: {
      normal: true,
      co2: true,
      constantPressure: false
    },
    moisture: {
      highMoistureSuitable: isMitsubishiRvsUnit(unit)
    }
  };
}

  if (isZehnder) {
    const counterflow = airflowType === "counterflow";
    const rotary = airflowType === "rotary";

    return {
      controllers: {
        Eco: !isEversky,
        Lobby: !isEversky,
        Diva: true
      },
      packages: {
        First: true,
        Smart: counterflow,
        "Premium BE": counterflow || rotary,
        "Premium CO": counterflow || rotary,
        Infinite: counterflow
      },
      heaters: {
        electricPreHeater: counterflow,
        electricPostHeater: counterflow || rotary,
        waterPostHeater: counterflow || rotary
      },
      controls: {
        normal: true,
        co2: true,
        constantPressure: false
      },
      moisture: {
        highMoistureSuitable: isMitsubishiRvsUnit(unit)
      }
    };
  }

  return {
    controllers: {
      Eco: false,
      Lobby: false,
      Diva: false
    },
    packages: {
      First: false,
      Smart: false,
      "Premium BE": false,
      "Premium CO": false,
      Infinite: false
    },
    heaters: {
      electricPreHeater: !!unit.heaterOptions?.electricPreHeater,
      electricPostHeater: !!unit.heaterOptions?.electricPostHeater,
      waterPostHeater: !!unit.heaterOptions?.waterPostHeater
    },
    controls: {
      normal: true,
      co2: false,
      constantPressure: false
    },
    moisture: {
      highMoistureSuitable: isMitsubishiRvsUnit(unit)
    }
  };
}

const SHAPED_COMMERCIAL_MVHR_UNITS = COMMERCIAL_MVHR_UNITS.map((unit) => ({
  ...unit,
  heatRecoveryPct: unit.heatRecoveryPct ?? null,
  capabilities: buildCapabilities(unit)
}));

const ENRICHED_COMMERCIAL_MVHR_UNITS = SHAPED_COMMERCIAL_MVHR_UNITS.map(enrichCommercialUnit);

  function getRoomOptionsHtml() {
    return Object.entries(ROOM_RULES)
      .map(([value, rule]) => `<option value="${escapeHtml(value)}">${escapeHtml(rule.label)}</option>`)
      .join("");
  }

  function getRoomRowHtml(defaultType) {
    return `
      <tr class="bpc-room-row">
        <td>
          <select class="bpc-input bpc-room-type">${getRoomOptionsHtml()}</select>
        </td>
        <td><input class="bpc-input bpc-room-name" type="text" placeholder="Optional name"></td>
        <td><input class="bpc-input bpc-room-length" type="number" min="0" step="0.1" placeholder="Length"></td>
        <td><input class="bpc-input bpc-room-width" type="number" min="0" step="0.1" placeholder="Width"></td>
        <td><input class="bpc-input bpc-room-height" type="number" min="0" step="0.1" value="2.5" placeholder="Height"></td>
        <td><input class="bpc-input bpc-room-occupancy" type="number" min="0" step="1" placeholder="People"></td>
        <td><button type="button" class="bpc-remove-row" aria-label="Remove row">×</button></td>
      </tr>
    `;
  }

  function isZehnderUnit(unit) {
  const brand = String(unit?.brand || "").toLowerCase();
  const name = String(unit?.name || "").toLowerCase();
  const model = String(unit?.model || "").toLowerCase();

  return (
    brand.includes("zehnder") ||
    name.includes("zehnder") ||
    model.includes("neotime") ||
    model.includes("flatpower") ||
    model.includes("eversky") ||
    model.includes("carma") ||
    model.includes("silvertop") ||
    model.includes("freetime") ||
    model.includes("hexamotion")
  );
}

function getZehnderAirflowType(unit) {
  if (unit.heatExchanger?.counterflowPvcAlu) return "counterflow";
  if (unit.heatExchanger?.rotaryWheel) return "rotary";
  return null;
}

function getDefaultControllerForUnit(unit) {
  const model = String(unit?.model || "").toLowerCase();
  const name = String(unit?.name || "").toLowerCase();

  if (model.includes("eversky") || name.includes("eversky")) return "Diva";
  return "Eco";
}

function getAllowedControllersForUnit(unit) {
  const model = String(unit?.model || "").toLowerCase();
  const name = String(unit?.name || "").toLowerCase();

  if (model.includes("eversky") || name.includes("eversky")) {
    return ["Diva"];
  }

  return ["Eco", "Lobby", "Diva"];
}

function resolveZehnderHeaterLabel(unit, options) {
  const airflowType = getZehnderAirflowType(unit);
  if (!airflowType) return "First";

  const hasPre = !!options.electricPreHeater;
  const hasPostElec = !!options.electricPostHeater;
  const hasPostWater = !!options.waterPostHeater;

  if (airflowType === "counterflow") {
    if (hasPre && hasPostElec) return "Infinite";
    if (hasPre) return "Smart";
    if (hasPostElec) return "Premium BE";
    if (hasPostWater) return "Premium CO";
    return "First";
  }

  if (airflowType === "rotary") {
    if (hasPostElec) return "Premium BE";
    if (hasPostWater) return "Premium CO";
    return "First";
  }

  return "First";
}

function getZehnderOptionsHtml(unit) {
  if (!isZehnderUnit(unit)) return "";

  const airflowType = getZehnderAirflowType(unit);
  const allowedControllers = getAllowedControllersForUnit(unit);
  const defaultController = getDefaultControllerForUnit(unit);

  return `
    <div class="bpc-unit-options" id="zehnderOptionsBox" style="margin-top:14px;">
      <div class="bpc-label" style="margin-bottom:8px;">Zehnder options</div>

      <div style="margin-bottom:10px;">
        <strong>Airflow type:</strong> ${escapeHtml(airflowType || "—")}
      </div>

      <div style="display:grid; gap:8px; margin-bottom:12px;">
        ${
          airflowType === "counterflow"
            ? `
              <label><input type="checkbox" id="optElectricPreHeater"> Electric preheater</label>
              <label><input type="checkbox" id="optElectricPostHeater"> Electric post heater</label>
              <label><input type="checkbox" id="optWaterPostHeater"> Water post heater</label>
            `
            : `
              <label><input type="checkbox" id="optElectricPostHeater"> Electric post heater</label>
              <label><input type="checkbox" id="optWaterPostHeater"> Water post heater</label>
            `
        }
      </div>

      <div style="margin-bottom:12px;">
        <label class="bpc-label" for="optController">Controller</label>
        <select id="optController" class="bpc-input">
          ${allowedControllers
            .map((value) => `<option value="${escapeHtml(value)}" ${value === defaultController ? "selected" : ""}>${escapeHtml(value)}</option>`)
            .join("")}
        </select>
      </div>

      <div id="resolvedCommercialTitle" class="bpc-unit-reco__meta"></div>
    </div>
  `;
}

function isMitsubishiUnit(unit) {
  const brand = String(unit?.brand || "").toLowerCase();
  const name = String(unit?.name || "").toLowerCase();
  const model = String(unit?.model || "").toLowerCase();
  const sku = String(unit?.sku || "").toLowerCase();

  return (
    brand.includes("mitsubishi") ||
    name.includes("lossnay") ||
    model.includes("lgh") ||
    sku.includes("lgh")
  );
}

function getMitsubishiOptionsHtml(unit) {
  if (!isMitsubishiUnit(unit)) return "";

  return `
    <div class="bpc-unit-options" id="mitsubishiOptionsBox" style="margin-top:14px;">
      <div class="bpc-label" style="margin-bottom:8px;">Optional Mitsubishi add-ons</div>

      <div style="display:grid; gap:8px; margin-bottom:12px;">
        ${MITSUBISHI_ACCESSORIES.map((item) => `
          <label>
            <input type="checkbox" class="bpc-mitsubishi-addon" value="${escapeHtml(item.sku)}">
            ${escapeHtml(item.name)}
          </label>
        `).join("")}
      </div>

      <div id="resolvedMitsubishiAddons" class="bpc-unit-reco__meta"></div>
    </div>
  `;
}

function resolveZehnderDisplayName(unit, options) {
  const baseName = String(unit?.name || unit?.sku || "").trim();
  const allowedControllers = getAllowedControllersForUnit(unit);
  const controller = allowedControllers.includes(options.controller)
    ? options.controller
    : getDefaultControllerForUnit(unit);

  const heaterLabel = resolveZehnderHeaterLabel(unit, options);

  let resolved = baseName;

  resolved = resolved.replace(/\bFirst\b/gi, heaterLabel);
  resolved = resolved.replace(/\bECO\b/gi, controller);
  resolved = resolved.replace(/\bEco\b/gi, controller);
  resolved = resolved.replace(/\bLobby\b/gi, controller);
  resolved = resolved.replace(/\bDiva\b/gi, controller);

  if (!/\b(First|Smart|Premium BE|Premium CO|Infinite)\b/i.test(resolved)) {
    resolved += ` ${heaterLabel}`;
  }

  if (!/\b(Eco|Lobby|Diva)\b/i.test(resolved)) {
    resolved += ` ${controller}`;
  }

  return resolved.replace(/\s+/g, " ").trim();
}

  function addRoomRow(root, defaultType) {
  const tbody = root.querySelector("#roomRows");
  if (!tbody) return;

  tbody.insertAdjacentHTML("beforeend", getRoomRowHtml(defaultType));
  const row = tbody.lastElementChild;
  const typeSelect = row.querySelector(".bpc-room-type");
  if (typeSelect) typeSelect.value = defaultType || "offices";

  row.querySelector(".bpc-remove-row")?.addEventListener("click", function () {
    row.remove();
    root.dispatchEvent(new Event("change", { bubbles: true }));
  });
}

  function calculateRoomResult(room) {
    const rule = ROOM_RULES[room.type];
    if (!rule) throw new Error("Unknown room type.");

    const length = toNumber(room.length);
    const width = toNumber(room.width);
    const height = toNumber(room.height);
    const occupancy = toNumber(room.occupancy);

    if (length <= 0 || width <= 0 || height <= 0) {
      throw new Error("Length, width and height must all be greater than 0.");
    }

    const areaM2 = length * width;
    const areaM3 = areaM2 * height;
    const achM3h = areaM3 * toNumber(rule.ach);

    let occupancyM3h = null;
    let occupancyMethod = "";

    if (occupancy > 0 && toNumber(rule.lsPerPerson) > 0) {
      occupancyM3h = occupancy * toNumber(rule.lsPerPerson) * 3.6;
      occupancyMethod = "Entered occupancy";
    } else if (toNumber(rule.minM2PerPerson) > 0 && toNumber(rule.lsPerPerson) > 0) {
      const inferredOccupancy = areaM2 / toNumber(rule.minM2PerPerson);
      occupancyM3h = inferredOccupancy * toNumber(rule.lsPerPerson) * 3.6;
      occupancyMethod = `Fallback from m²/person (${fmt(inferredOccupancy, 1)} people)`;
    }

    let selectedM3h = achM3h;
let selectedBasis = "ACH";

if (occupancyM3h != null && occupancyM3h > 0) {
  selectedM3h = Math.min(achM3h, occupancyM3h);
  selectedBasis = selectedM3h === achM3h ? "ACH" : "Occupancy";
}

    return {
      ...room,
      ruleLabel: rule.label,
      ach: toNumber(rule.ach),
      lsPerPerson: toNumber(rule.lsPerPerson),
      minM2PerPerson: toNumber(rule.minM2PerPerson),
      areaM2: round2(areaM2),
      areaM3: round2(areaM3),
      achM3h: round2(achM3h),
      occupancyM3h: occupancyM3h == null ? null : round2(occupancyM3h),
      occupancyMethod,
      selectedM3h: round2(selectedM3h),
      selectedLs: round2(selectedM3h / 3.6),
      selectedBasis
    };
  }

function formatUnitBadges(unit) {
  const badges = [];
  if (unit.location?.indoor) badges.push("Indoor");
  if (unit.location?.outdoor || unit.outdoorRainHoodRequired) badges.push("Outdoor rain-protected range");
  if (unit.location?.decentralised) badges.push("Decentralised");
  if (unit.mounting?.ceiling) badges.push("Ceiling");
  if (unit.mounting?.floorTop) badges.push("Floor top");
  if (unit.mounting?.floorSide) badges.push("Floor side");
  if (unit.mountingLabel) badges.push(unit.mountingLabel);
  if (unit.heatExchanger?.counterflowWax) badges.push("Counterflow wax");
  if (unit.heatExchanger?.counterflowPvcAlu) badges.push("Counterflow PVC/Alu");
  if (unit.heatExchanger?.rotaryWheel) badges.push("Rotary wheel");
  if (unit.heaterOptions?.electricPreHeater) badges.push("Elec pre-heater");
  if (unit.heaterOptions?.electricPostHeater) badges.push("Elec post-heater");
  if (unit.heaterOptions?.waterPostHeater) badges.push("Water post-heater");
  return badges.length ? badges.join(" · ") : "—";
}

function getUnitMetaHtml(unit) {
  if (!unit) return "";
  return `
    <div class="bpc-unit-reco__meta">
      SKU: ${escapeHtml(unit.sku || "—")}<br>
      Brand: ${escapeHtml(unit.brand || "—")}<br>
      Model: ${escapeHtml(unit.model || "—")}<br>
      Rated airflow @100Pa: ${escapeHtml(fmt(unit.ratedFlowAt100PaM3h, 0))} m³/h<br>
      Recommended duty (75% rule): ${escapeHtml(fmt(unit.recommendedMaxM3h, 0))} m³/h<br>
      Catalogue max airflow: ${escapeHtml(fmt(unit.maxFlowM3h, 0))} m³/h<br>
      Heat recovery: ${unit.heatRecoveryPct == null ? "—" : `${escapeHtml(fmt(unit.heatRecoveryPct, 0))}%`}<br>
      Controls included: ${unit.controlIncluded ? "Yes" : "No"}<br>
      Phase: ${escapeHtml(unit.phase || "—")}<br>
      Spigot: ${escapeHtml(unit.spigot || "—")}<br>
      Heater: ${escapeHtml(unit.heaterLabel || "None")} ${unit.heaterKw ? `(${escapeHtml(fmt(unit.heaterKw, 1))} kW)` : ""}<br>
      ${unit.outdoorRainHoodRequired ? `<div class="bpc-unit-note"><strong>Outdoor note:</strong> This range can be used for rain-protected outdoor selections, but an additional rain hood is required and is POA.</div>` : ""}
      Attributes: ${escapeHtml(formatUnitBadges(unit))}
    </div>
    
    ${getZehnderOptionsHtml(unit)}
    ${getMitsubishiOptionsHtml(unit)}
  `;
}

function getEligibleCommercialUnits(root, totalM3h) {
  const requiredM3h = Math.ceil(Number(totalM3h || 0));
  const filters = getSelectedFilters(root);

  const allMatchingFilters = ENRICHED_COMMERCIAL_MVHR_UNITS
    .filter((unit) => unitMatchesFilters(unit, filters, root))
    .sort((a, b) => {
      const aRated = Number(a.ratedFlowAt100PaM3h || a.maxFlowM3h || 0);
      const bRated = Number(b.ratedFlowAt100PaM3h || b.maxFlowM3h || 0);
      return aRated - bRated;
    });

  const capableByRecommendedDuty = allMatchingFilters.filter((unit) => {
    return requiredM3h <= Number(unit.recommendedMaxM3h || 0);
  });

  const baseSuggestedUnit = capableByRecommendedDuty[0] || null;
  const baseSuggestedRatedM3h = baseSuggestedUnit
    ? Number(baseSuggestedUnit.ratedFlowAt100PaM3h || baseSuggestedUnit.maxFlowM3h || 0)
    : 0;

  const maxSelectableRatedM3h = baseSuggestedRatedM3h
    ? round2(baseSuggestedRatedM3h * 1.3)
    : 0;

  const selectableUnits = capableByRecommendedDuty.filter((unit) => {
    const rated = Number(unit.ratedFlowAt100PaM3h || unit.maxFlowM3h || 0);

    return (
      baseSuggestedRatedM3h > 0 &&
      rated >= baseSuggestedRatedM3h &&
      rated <= maxSelectableRatedM3h
    );
  });

  const nextOversizedUnit = capableByRecommendedDuty.find((unit) => {
    const rated = Number(unit.ratedFlowAt100PaM3h || unit.maxFlowM3h || 0);
    return maxSelectableRatedM3h > 0 && rated > maxSelectableRatedM3h;
  }) || null;

  return {
    requiredM3h,
    allMatchingFilters,
    capableByRecommendedDuty,
    baseSuggestedUnit,
    baseSuggestedRatedM3h,
    maxSelectableRatedM3h,
    selectableUnits,
    nextOversizedUnit
  };
}

function recommendUnits(root, totalM3h, pressurePa) {
  const selection = getEligibleCommercialUnits(root, totalM3h);
  const requiredM3h = selection.requiredM3h;

  if (!ENRICHED_COMMERCIAL_MVHR_UNITS.length) {
    return `
      <div class="bpc-empty">
        No unit map loaded.<br>
        Current requirement: <strong>${escapeHtml(fmt(requiredM3h, 0))} m³/h @ ${escapeHtml(fmt(pressurePa, 0))} Pa</strong>
      </div>
    `;
  }

  const eligible = selection.selectableUnits;
  const filters = getSelectedFilters(root);
  const selectionNotes = [];

  if (filters.moisture === "high_moisture") {
    selectionNotes.push("High moisture selected: only Mitsubishi LGH RVS-E units are suitable.");
  }

  if (filters.location === "outdoor_rain_protected") {
    selectionNotes.push("Outdoor rain-protected selected: only Caladair CARMA, HEXAMOTION and EXAECO ranges are suitable. These require an additional rain hood, which is POA.");
  }

  const selectionNotesHtml = selectionNotes.length
    ? `<div class="bpc-selection-note">${selectionNotes.map((note) => `<div>${escapeHtml(note)}</div>`).join("")}</div>`
    : "";

if (!eligible.length) {
  const fallback = selection.nextOversizedUnit;

  return `
    ${selectionNotesHtml}
    <div class="bpc-warning">
      No single unit is available inside the 30% sizing range for
      <strong>${escapeHtml(fmt(requiredM3h, 0))} m³/h @ ${escapeHtml(fmt(pressurePa, 0))} Pa</strong>.

      <br><br>
      Allowed rated airflow range:
      <strong>${escapeHtml(fmt(requiredM3h, 0))}–${escapeHtml(fmt(selection.maxSelectableRatedM3h, 0))} m³/h</strong>.

      ${
        fallback
          ? `<br><br>The next technically capable unit appears to be <strong>${escapeHtml(fallback.name || fallback.model || fallback.sku)}</strong>
          at <strong>${escapeHtml(fmt(fallback.ratedFlowAt100PaM3h || fallback.maxFlowM3h, 0))} m³/h</strong>,
          but it is outside the 30% cap so it has not been added to the selectable list.`
          : ""
      }

      <br><br>
      Please speak to BPC for a design-led selection.
    </div>
  `;
}

const best = eligible[0];
const options = eligible
    .map((unit) => {
      const label = `${unit.name || unit.model || unit.sku} — ${fmt(unit.ratedFlowAt100PaM3h, 0)} m³/h rated`;
      return `<option value="${escapeHtml(unit.sku)}">${escapeHtml(label)}</option>`;
    })
    .join("");

  const oversizeWarning = "";

  return `
    ${selectionNotesHtml}
    ${oversizeWarning}

    <div class="bpc-unit-reco">
      <div class="bpc-unit-reco__title">Recommended unit</div>
      <div class="bpc-unit-reco__name">${escapeHtml(best.name || best.model || best.sku)}</div>

      <div class="bpc-unit-reco__meta">
        Required airflow: <strong>${escapeHtml(fmt(requiredM3h, 0))} m³/h</strong><br>
Selectable unit range: <strong>${escapeHtml(fmt(selection.baseSuggestedRatedM3h, 0))}–${escapeHtml(fmt(selection.maxSelectableRatedM3h, 0))} m³/h rated</strong><br>        Design pressure: <strong>${escapeHtml(fmt(pressurePa, 0))} Pa</strong>
      </div>

      <div class="bpc-unit-options">
        <label class="bpc-label" for="commercialUnitSelect">Selected commercial unit</label>
        <select id="commercialUnitSelect" class="bpc-input">
          ${options}
        </select>

        <div id="commercialUnitDetails" style="margin-top:12px;">
          ${getUnitMetaHtml(best)}
        </div>
      </div>
    </div>
  `;
}

  function renderSummary(root, totals, pressurePa) {
    const summary = root.querySelector("#summaryBox");
    if (!summary) return;

    summary.innerHTML = `
      <div class="bpc-hero">
        <div class="bpc-hero__label">Total required airflow</div>
        <div class="bpc-hero__value">${escapeHtml(fmt(totals.totalM3h, 0))} m³/h</div>
        <div class="bpc-hero__sub">${escapeHtml(fmt(totals.totalLs, 1))} L/s</div>
        <div class="bpc-hero__meta">${escapeHtml(fmt(totals.roomCount, 0))} room(s) · ${escapeHtml(fmt(pressurePa, 0))} Pa design pressure</div>
      </div>

      <div class="bpc-stat-grid">
        <div class="bpc-stat">
          <div class="bpc-stat__label">Rooms counted</div>
          <div class="bpc-stat__value">${escapeHtml(fmt(totals.roomCount, 0))}</div>
        </div>
        <div class="bpc-stat">
          <div class="bpc-stat__label">Total m³/h</div>
          <div class="bpc-stat__value">${escapeHtml(fmt(totals.totalM3h, 0))}</div>
        </div>
        <div class="bpc-stat">
          <div class="bpc-stat__label">Total L/s</div>
          <div class="bpc-stat__value">${escapeHtml(fmt(totals.totalLs, 1))}</div>
        </div>
        <div class="bpc-stat">
          <div class="bpc-stat__label">Design pressure</div>
          <div class="bpc-stat__value">${escapeHtml(fmt(pressurePa, 0))} Pa</div>
        </div>
      </div>
    `;
  }

  function renderResults(root, roomResults) {
    const box = root.querySelector("#resultsBox");
    if (!box) return;

    if (!roomResults.length) {
      box.innerHTML = `<div class="bpc-empty">No valid rooms to calculate.</div>`;
      return;
    }

    const rows = roomResults.map((room, index) => `
      <tr>
        <td>${index + 1}</td>
        <td>${escapeHtml(room.ruleLabel)}</td>
        <td>${escapeHtml(room.name || "—")}</td>
        <td>${escapeHtml(fmt(room.areaM2, 2))}</td>
        <td>${escapeHtml(fmt(room.areaM3, 2))}</td>
        <td>${escapeHtml(fmt(room.achM3h, 0))}</td>
        <td>${room.occupancyM3h == null ? "—" : escapeHtml(fmt(room.occupancyM3h, 0))}</td>
        <td>${escapeHtml(room.selectedBasis)}</td>
        <td><strong>${escapeHtml(fmt(room.selectedM3h, 0))}</strong></td>
      </tr>
    `).join("");

    box.innerHTML = `
      <div class="bpc-results-section">
        <h3>Calculated airflow by room</h3>
        <div class="bpc-table-wrap">
          <table class="bpc-results-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Room type</th>
                <th>Name</th>
                <th>Area m²</th>
                <th>Volume m³</th>
                <th>ACH m³/h</th>
                <th>Occupancy m³/h</th>
                <th>Used</th>
                <th>Result m³/h</th>
              </tr>
            </thead>
            <tbody>${rows}</tbody>
          </table>
        </div>
      </div>
    `;
  }

  function addExampleRooms(root) {
  const tbody = root.querySelector("#roomRows");
  if (!tbody) return;

  tbody.innerHTML = "";

  const examples = [
    { type: "offices", name: "Main Office", length: 10, width: 10, height: 2.5, occupancy: 10 },
    { type: "meeting_room", name: "Board Room", length: 6, width: 5, height: 2.5, occupancy: 8 },
    { type: "toilets", name: "Toilets", length: 4, width: 3, height: 2.5, occupancy: 0 },
    { type: "entrance_hall", name: "Entrance Hall", length: 8, width: 4, height: 2.8, occupancy: 10 }
  ];

  examples.forEach((item) => {
    addRoomRow(root, item.type);
    const row = tbody.lastElementChild;
    if (!row) return;

    const typeEl = row.querySelector(".bpc-room-type");
    const nameEl = row.querySelector(".bpc-room-name");
    const lengthEl = row.querySelector(".bpc-room-length");
    const widthEl = row.querySelector(".bpc-room-width");
    const heightEl = row.querySelector(".bpc-room-height");
    const occEl = row.querySelector(".bpc-room-occupancy");

    if (typeEl) typeEl.value = item.type;
    if (nameEl) nameEl.value = item.name;
    if (lengthEl) lengthEl.value = item.length;
    if (widthEl) widthEl.value = item.width;
    if (heightEl) heightEl.value = item.height;
    if (occEl) occEl.value = item.occupancy;
  });
}

function collectRooms(root) {
  const rows = Array.from(root.querySelectorAll(".bpc-room-row"));

  return rows.map((row) => ({
    type: String(row.querySelector(".bpc-room-type")?.value || "").trim(),
    name: String(row.querySelector(".bpc-room-name")?.value || "").trim(),
    length: row.querySelector(".bpc-room-length")?.value,
    width: row.querySelector(".bpc-room-width")?.value,
    height: row.querySelector(".bpc-room-height")?.value,
    occupancy: row.querySelector(".bpc-room-occupancy")?.value
  }));
}

function calculateAll(root) {
  const rooms = collectRooms(root);

  if (!rooms.length) {
    throw new Error("Please add at least one room.");
  }

  const roomResults = rooms.map(calculateRoomResult);
  const totalM3h = roomResults.reduce((sum, room) => sum + toNumber(room.selectedM3h), 0);
  const totalLs = totalM3h / 3.6;

  return {
    roomResults,
    totals: {
      roomCount: roomResults.length,
      totalM3h: round2(totalM3h),
      totalLs: round2(totalLs)
    }
  };
}

function getInputMode(root) {
  return String(root.querySelector("#inputMode")?.value || "rooms");
}

function toggleOutdoorRainNote(root) {
  const note = root.querySelector("#outdoorRainNote");
  const location = String(root.querySelector("#filterLocation")?.value || "");
  if (note) note.hidden = location !== "outdoor_rain_protected";
}

function toggleInputMode(root) {
  const mode = getInputMode(root);
  const manualWrap = root.querySelector("#manualFlowWrap");
  const roomsWrap = root.querySelector(".bpc-rooms-wrap");
  const roomToolbar = root.querySelector(".bpc-room-toolbar");

  if (manualWrap) manualWrap.style.display = mode === "manual" ? "" : "none";
  if (roomsWrap) roomsWrap.style.display = mode === "rooms" ? "" : "none";
  if (roomToolbar) roomToolbar.style.display = mode === "rooms" ? "" : "none";
}

function getSelectedFilters(root) {
  return {
    location: String(root.querySelector("#filterLocation")?.value || ""),
    orientation: String(root.querySelector("#filterOrientation")?.value || ""),
    heatExchanger: String(root.querySelector("#filterHeatExchanger")?.value || ""),
    moisture: String(root.querySelector("#filterMoisture")?.value || ""),
    heater: String(root.querySelector("#filterHeater")?.value || "")
  };
}

function bindRecommendedUnitDetails(root, eligible) {
  const select = root.querySelector("#commercialUnitSelect");
  const details = root.querySelector("#commercialUnitDetails");
  if (!select || !details || !eligible.length) return;

  function renderResolvedTitle(unit) {
  const box = root.querySelector("#resolvedCommercialTitle");
  if (!box || !unit || !isZehnderUnit(unit)) return;

  const electricPreHeater = !!root.querySelector("#optElectricPreHeater")?.checked;
  const electricPostHeater = !!root.querySelector("#optElectricPostHeater")?.checked;
  const waterPostHeater = !!root.querySelector("#optWaterPostHeater")?.checked;
  const controller =
    root.querySelector("#optController")?.value || getDefaultControllerForUnit(unit);

  const resolvedName = resolveZehnderDisplayName(unit, {
    electricPreHeater,
    electricPostHeater,
    waterPostHeater,
    controller
  });

  const packageLabel = resolveZehnderHeaterLabel(unit, {
    electricPreHeater,
    electricPostHeater,
    waterPostHeater,
    controller
  });

  box.innerHTML = `
    <strong>Resolved commercial name:</strong><br>
    ${escapeHtml(resolvedName)}<br>
    <small>
      Package: ${escapeHtml(packageLabel || "First")} ·
      Controller: ${escapeHtml(controller || "Eco")}
    </small>
  `;
}

  function renderMitsubishiAddons(unit) {
    const box = root.querySelector("#resolvedMitsubishiAddons");
    if (!box || !unit || !isMitsubishiUnit(unit)) return;

    const checked = Array.from(root.querySelectorAll(".bpc-mitsubishi-addon:checked"))
      .map((el) => el.value);

    if (!checked.length) {
      box.innerHTML = `<strong>Selected add-ons:</strong><br>None`;
      return;
    }

    const selectedItems = MITSUBISHI_ACCESSORIES.filter((item) => checked.includes(item.sku));

    box.innerHTML = `
      <strong>Selected add-ons:</strong><br>
      ${selectedItems.map((item) => `${escapeHtml(item.sku)} — ${escapeHtml(item.name)}`).join("<br>")}
    `;
  }

  function bindOptionEvents(unit) {
  [
    "#optElectricPreHeater",
    "#optElectricPostHeater",
    "#optWaterPostHeater",
    "#optController"
  ].forEach((selector) => {
    const el = root.querySelector(selector);
    if (!el) return;

    el.addEventListener("change", function () {
      if (selector === "#optElectricPostHeater" && el.checked) {
        const water = root.querySelector("#optWaterPostHeater");
        if (water) water.checked = false;
      }

      if (selector === "#optWaterPostHeater" && el.checked) {
        const elec = root.querySelector("#optElectricPostHeater");
        if (elec) elec.checked = false;
      }

      renderResolvedTitle(unit);
    });
  });

  root.querySelectorAll(".bpc-mitsubishi-addon").forEach((el) => {
    el.addEventListener("change", function () {
      renderMitsubishiAddons(unit);
    });
  });
}

  function renderSelected() {
    const selected = eligible.find((u) => u.sku === select.value) || eligible[0];
    details.innerHTML = getUnitMetaHtml(selected);
    bindOptionEvents(selected);
    renderResolvedTitle(selected);
    renderMitsubishiAddons(selected);
  }

  select.addEventListener("change", renderSelected);
  renderSelected();
}


function getRequestedPackageFromFilters(root, unit) {
  const filters = getSelectedFilters(root);
  const airflowType = getZehnderAirflowType(unit);

  if (!airflowType) return "First";

  if (airflowType === "counterflow") {
    if (filters.heater === "electric_pre") return "Smart";
    if (filters.heater === "electric_post") return "Premium BE";
    if (filters.heater === "water_post") return "Premium CO";
    return "First";
  }

  if (airflowType === "rotary") {
    if (filters.heater === "electric_post") return "Premium BE";
    if (filters.heater === "water_post") return "Premium CO";
    return "First";
  }

  return "First";
}

function getResolvedOptionsFromFilters(root, unit) {
  const filters = getSelectedFilters(root);

  const base = {
    electricPreHeater: filters.heater === "electric_pre",
    electricPostHeater: filters.heater === "electric_post",
    waterPostHeater: filters.heater === "water_post"
  };

  if (isZehnderUnit(unit)) {
    return {
      ...base,
      controller: null,
      packageLabel: getRequestedPackageFromFilters(root, unit)
    };
  }

  return {
    ...base,
    controller: null,
    packageLabel: null
  };
}

function unitSupportsResolvedOptions(unit, options) {
  const caps = unit.capabilities || {};
  const controllers = caps.controllers || {};
  const packages = caps.packages || {};
  const heaters = caps.heaters || {};
  const controls = caps.controls || {};
  const moisture = caps.moisture || {};

  if (options.controller && controllers[options.controller] === false) return false;
  if (options.packageLabel && packages[options.packageLabel] === false) return false;

  if (options.electricPreHeater && heaters.electricPreHeater === false) return false;
  if (options.electricPostHeater && heaters.electricPostHeater === false) return false;
  if (options.waterPostHeater && heaters.waterPostHeater === false) return false;

  const filters = options._filters || {};
  if (filters.moisture === "high_moisture" && moisture.highMoistureSuitable === false) return false;

  return true;
}

function unitMatchesFilters(unit, filters, root) {
  if (filters.location === "outdoor_rain_protected" && !isOutdoorRainProtectedRange(unit)) return false;
  if (filters.moisture === "high_moisture" && !isMitsubishiRvsUnit(unit)) return false;

  if (filters.location && unit.locationType !== filters.location) return false;

  if (filters.orientation) {
    if (filters.orientation === "floor") {
      if (!(unit.orientationType === "floor_top" || unit.orientationType === "floor_side")) return false;
    } else if (unit.orientationType !== filters.orientation) {
      return false;
    }
  }

  if (filters.heatExchanger && unit.heatExchangerType !== filters.heatExchanger) return false;

  if (filters.moisture === "high_moisture" && unit.highMoistureSuitable === false) return false;

  const resolved = getResolvedOptionsFromFilters(root, unit);
  resolved._filters = filters;

  return unitSupportsResolvedOptions(unit, resolved);
}


function getCommercialSelections(root) {
  const filters = getSelectedFilters(root);

  return {
    electricPreHeater: filters.heater === "electric_pre",
    electricPostHeater: filters.heater === "electric_post",
    waterPostHeater: filters.heater === "water_post",
  };
}

function getRequiredAirflow(root) {
  const mode = getInputMode(root);

  if (mode === "manual") {
    const manualRequiredM3h = toNumber(root.querySelector("#manualRequiredM3h")?.value, 0);
    if (manualRequiredM3h <= 0) {
      throw new Error("Please enter a required airflow in m³/h.");
    }

    return {
      roomResults: [],
      totals: {
        roomCount: 0,
        totalM3h: round2(manualRequiredM3h),
        totalLs: round2(manualRequiredM3h / 3.6)
      }
    };
  }

  return calculateAll(root);
}

function getSelectedCommercialConfiguration(root) {
  const unitSelect = root.querySelector("#commercialUnitSelect");
  const unit = ENRICHED_COMMERCIAL_MVHR_UNITS.find((u) => u.sku === unitSelect?.value) || null;

  const zehnderOptions = unit && isZehnderUnit(unit)
    ? {
        electricPreHeater: !!root.querySelector("#optElectricPreHeater")?.checked,
        electricPostHeater: !!root.querySelector("#optElectricPostHeater")?.checked,
        waterPostHeater: !!root.querySelector("#optWaterPostHeater")?.checked,
        controller: root.querySelector("#optController")?.value || getDefaultControllerForUnit(unit),
        resolvedName: resolveZehnderDisplayName(unit, {
          electricPreHeater: !!root.querySelector("#optElectricPreHeater")?.checked,
          electricPostHeater: !!root.querySelector("#optElectricPostHeater")?.checked,
          waterPostHeater: !!root.querySelector("#optWaterPostHeater")?.checked,
          controller: root.querySelector("#optController")?.value || getDefaultControllerForUnit(unit)
        })
      }
    : null;

  const mitsubishiAddons = unit && isMitsubishiUnit(unit)
    ? MITSUBISHI_ACCESSORIES.filter((item) =>
        Array.from(root.querySelectorAll(".bpc-mitsubishi-addon:checked")).some((el) => el.value === item.sku)
      )
    : [];

  return {
    selectedUnit: unit,
    zehnderOptions,
    mitsubishiAddons
  };
}

  function initCommercialMvhr() {

    function updateModeUi() {
  toggleInputMode(root);

  const mode = getInputMode(root);

  if (resultsCard) {
    resultsCard.style.display = mode === "rooms" ? "" : "none";
  }

  const summary = root.querySelector("#summaryBox");
  const results = root.querySelector("#resultsBox");

  if (mode === "manual") {
    if (summary) {
      summary.innerHTML = `<div class="bpc-empty">Enter required airflow and press calculate.</div>`;
    }
    if (results) {
      results.innerHTML = `<div class="bpc-empty">Room-by-room results are hidden when using manual airflow input.</div>`;
    }
  } else {
    if (summary) {
      summary.innerHTML = `<div class="bpc-empty">Add rooms and press calculate.</div>`;
    }
    if (results) {
      results.innerHTML = `<div class="bpc-empty">No calculation yet.</div>`;
    }
  }
}
function refreshCalculator() {
    toggleOutdoorRainNote(root);
  try {
    const pressurePa = toNumber(root.querySelector("#pressurePa")?.value, 100);
    const out = getRequiredAirflow(root);

    renderSummary(root, out.totals, pressurePa);

    if (unitRecommendation) {
      unitRecommendation.innerHTML = recommendUnits(root, out.totals.totalM3h, pressurePa);

     const unitSelection = getEligibleCommercialUnits(root, out.totals.totalM3h);
bindRecommendedUnitDetails(root, unitSelection.selectableUnits);
    }

    if (getInputMode(root) === "rooms") {
      renderResults(root, out.roomResults);
    }
  } catch (error) {
    const summary = root.querySelector("#summaryBox");
    const results = root.querySelector("#resultsBox");
    if (summary) {
      summary.innerHTML = `<div class="bpc-error">${escapeHtml(error?.message || "Something went wrong.")}</div>`;
    }
    if (results) {
      results.innerHTML = `<div class="bpc-empty">Please correct the inputs and try again.</div>`;
    }
  }
}
    const root = document.getElementById("bpcCommercialMvhr");
    if (!root) return;

    window.BPC_COMMERCIAL_AI = {
  getSnapshot: function () {
    return getCommercialAiSnapshot(root);
  }
};

    const addRoomBtn = root.querySelector("#addRoomBtn");
    const addExampleRoomsBtn = root.querySelector("#addExampleRoomsBtn");
    const calculateBtn = root.querySelector("#calculateBtn");
    const resetBtn = root.querySelector("#resetBtn");
    const unitRecommendation = root.querySelector("#unitRecommendation");
    const inputMode = root.querySelector("#inputMode");
    const resultsCard = root.querySelector("#resultsBox")?.closest(".bpc-card");
    inputMode?.addEventListener("change", updateModeUi);
updateModeUi();

    function resetCalculator() {
  const tbody = root.querySelector("#roomRows");
  const summary = root.querySelector("#summaryBox");
  const results = root.querySelector("#resultsBox");
  const projectName = root.querySelector("#projectName");
  const pressurePa = root.querySelector("#pressurePa");
  const manualRequiredM3h = root.querySelector("#manualRequiredM3h");

  if (tbody) tbody.innerHTML = "";
  if (projectName) projectName.value = "";
  if (pressurePa) pressurePa.value = "100";
  if (manualRequiredM3h) manualRequiredM3h.value = "";

  addRoomRow(root, "offices");

  toggleOutdoorRainNote(root);

  if (unitRecommendation) {
    unitRecommendation.innerHTML = `<div class="bpc-empty">Unit recommendation will appear here once you add your SKU map.</div>`;
  }

  updateModeUi();

  if (summary && getInputMode(root) === "rooms") {
    summary.innerHTML = `<div class="bpc-empty">Add rooms and press calculate.</div>`;
  }

  if (summary && getInputMode(root) === "manual") {
    summary.innerHTML = `<div class="bpc-empty">Enter required airflow and press calculate.</div>`;
  }

  if (results && getInputMode(root) === "rooms") {
    results.innerHTML = `<div class="bpc-empty">No calculation yet.</div>`;
  }

  if (results && getInputMode(root) === "manual") {
    results.innerHTML = `<div class="bpc-empty">Room-by-room results are hidden when using manual airflow input.</div>`;
  }
}

function bindLiveEvents() {
  root.addEventListener("input", function (event) {
    const target = event.target;
    if (!target) return;

    if (
      target.matches(".bpc-room-length, .bpc-room-width, .bpc-room-height, .bpc-room-occupancy") ||
      target.matches("#manualRequiredM3h") ||
      target.matches("#pressurePa")
    ) {
      refreshCalculator();
    }
  });

  root.addEventListener("change", function (event) {
    const target = event.target;
    if (!target) return;

    if (
      target.matches(".bpc-room-type") ||
      target.matches("#inputMode") ||
      target.matches("#filterLocation") ||
      target.matches("#filterOrientation") ||
      target.matches("#filterHeatExchanger") ||
      target.matches("#filterMoisture") ||
      target.matches("#filterHeater")
    ) {
      refreshCalculator();
    }
  });
}



    addRoomRow(root, "offices");

addExampleRoomsBtn?.addEventListener("click", function () {
  addExampleRooms(root);
  refreshCalculator();
});

function getCommercialAiSnapshot(root) {
  try {
    const pressurePa = toNumber(root.querySelector("#pressurePa")?.value, 100);
    const out = getRequiredAirflow(root);
    const filters = getSelectedFilters(root);
    const unitSelection = getEligibleCommercialUnits(root, out.totals.totalM3h);
    const config = getSelectedCommercialConfiguration(root);

    const selectedUnit =
      config.selectedUnit ||
      unitSelection.baseSuggestedUnit ||
      unitSelection.selectableUnits?.[0] ||
      null;

    const selectedProduct = selectedUnit
      ? {
          sku: selectedUnit.sku || "",
          supplierPartNumber: selectedUnit.supplierPartNumber || "",
          name: selectedUnit.name || selectedUnit.model || selectedUnit.sku || "",
          brand: selectedUnit.brand || "",
          model: selectedUnit.model || "",
          ratedFlowAt100PaM3h: selectedUnit.ratedFlowAt100PaM3h || selectedUnit.maxFlowM3h || 0,
          maxFlowM3h: selectedUnit.maxFlowM3h || 0,
          recommendedMaxM3h: selectedUnit.recommendedMaxM3h || 0,
          heatRecoveryPct: selectedUnit.heatRecoveryPct,
          controlIncluded: !!selectedUnit.controlIncluded,
          phase: selectedUnit.phase || "",
          spigot: selectedUnit.spigot || "",
          heaterLabel: selectedUnit.heaterLabel || "",
          heaterKw: selectedUnit.heaterKw || 0,
          locationType: selectedUnit.locationType || "",
          orientationType: selectedUnit.orientationType || "",
          heatExchangerType: selectedUnit.heatExchangerType || "",
          attributes: formatUnitBadges(selectedUnit)
        }
      : null;

    return {
      inputMode: getInputMode(root),
      projectName: String(root.querySelector("#projectName")?.value || "").trim(),
      pressurePa,

      totals: out.totals,
      roomResults: out.roomResults,
      filters,

      selectedProduct,
      selectedUnit: selectedProduct,
      recommendedUnit: selectedProduct,

      selectedConfiguration: {
        ...config,
        selectedProduct
      },

      sizing: {
        requiredM3h: unitSelection.requiredM3h,
        baseSuggestedRatedM3h: unitSelection.baseSuggestedRatedM3h,
        maxSelectableRatedM3h: unitSelection.maxSelectableRatedM3h,
        selectableUnitCount: unitSelection.selectableUnits.length,
        selectableUnits: unitSelection.selectableUnits.map((unit) => ({
          sku: unit.sku || "",
          name: unit.name || unit.model || unit.sku || "",
          brand: unit.brand || "",
          model: unit.model || "",
          ratedFlowAt100PaM3h: unit.ratedFlowAt100PaM3h || unit.maxFlowM3h || 0,
          recommendedMaxM3h: unit.recommendedMaxM3h || 0
        })),
        nextOversizedUnit: unitSelection.nextOversizedUnit
          ? {
              sku: unitSelection.nextOversizedUnit.sku || "",
              name: unitSelection.nextOversizedUnit.name || unitSelection.nextOversizedUnit.model || unitSelection.nextOversizedUnit.sku || "",
              ratedFlowAt100PaM3h: unitSelection.nextOversizedUnit.ratedFlowAt100PaM3h || unitSelection.nextOversizedUnit.maxFlowM3h || 0
            }
          : null
      },

      explanationHints: {
        whyChosen:
          selectedProduct
            ? `${selectedProduct.name} was selected because the required airflow is ${fmt(out.totals.totalM3h, 0)} m³/h and this unit has a rated airflow of ${fmt(selectedProduct.ratedFlowAt100PaM3h, 0)} m³/h with a recommended duty of ${fmt(selectedProduct.recommendedMaxM3h, 0)} m³/h using the 75% rule.`
            : "No selected product was available in the calculator snapshot.",
        selectionRule:
          "The calculator picks the smallest unit whose recommended duty can meet the required airflow, then allows selectable alternatives up to 30% above the base selected rated airflow."
      }
    };
  } catch (error) {
    return {
      error: error?.message || "No valid calculation available yet."
    };
  }
}

function initCommercialAiChat() {
  const root = document.getElementById("bpcCommercialMvhr");
  const aiRoot = document.getElementById("bpcCommercialAi");

  if (!root || !aiRoot) return;

  const form = aiRoot.querySelector("#bpcAiForm");
  const input = aiRoot.querySelector("#bpcAiInput");
  const messages = aiRoot.querySelector("#bpcAiMessages");
  const status = aiRoot.querySelector("#bpcAiStatus");
  const chips = Array.from(aiRoot.querySelectorAll("[data-ai-question]"));

  /*
    For final app proxy setup use:
    const AI_ENDPOINT = "/apps/commercial-ai";

    For quick testing you can temporarily use your direct Worker URL:
    const AI_ENDPOINT = "https://YOUR-WORKER.YOUR-SUBDOMAIN.workers.dev";
  */
  const AI_ENDPOINT = "/apps/commercial-ai";

  function setStatus(text) {
    if (status) status.textContent = text;
  }

  function addMessage(text, type) {
  const messageType = type || "bot";
  const avatarUrl = aiRoot.getAttribute("data-bernie-avatar") || "";

  const row = document.createElement("div");
  row.className = `bpc-ai-row bpc-ai-row--${messageType}`;

  if ((messageType === "bot" || messageType === "error") && avatarUrl) {
    const avatar = document.createElement("div");
    avatar.className = "bpc-ai-mini-avatar";

    const img = document.createElement("img");
    img.src = avatarUrl;
    img.alt = "Commercial Bernie AI";
    img.loading = "lazy";

    avatar.appendChild(img);
    row.appendChild(avatar);
  }

  const div = document.createElement("div");
  div.className = `bpc-ai-message bpc-ai-message--${messageType}`;
  div.textContent = text;

  row.appendChild(div);
  messages.appendChild(row);
  messages.scrollTop = messages.scrollHeight;

  return div;
}

  function setLoading(isLoading) {
    if (input) input.disabled = isLoading;

    const send = aiRoot.querySelector(".bpc-ai-send");
    if (send) send.disabled = isLoading;

    chips.forEach((chip) => {
      chip.disabled = isLoading;
    });

    setStatus(isLoading ? "Thinking..." : "Ready");
  }

  async function askAi(question) {
    const cleanQuestion = String(question || "").trim();
    if (!cleanQuestion) return;

    addMessage(cleanQuestion, "user");
    setLoading(true);

    const loadingMessage = addMessage("Checking the calculator result...", "bot");

    try {
      const snapshot = window.BPC_COMMERCIAL_AI?.getSnapshot
        ? window.BPC_COMMERCIAL_AI.getSnapshot()
        : { error: "Calculator snapshot not available." };

      const response = await fetch(AI_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
  assistant: "commercial",
  message: cleanQuestion,
  snapshot
})
      });

      const data = await response.json();

      if (!response.ok || !data.ok) {
        throw new Error(data?.details || data?.error || "AI request failed.");
      }

      loadingMessage.textContent = data.answer || "Sorry, I could not generate an answer.";
    } catch (error) {
      loadingMessage.remove();
      addMessage(
        error?.message || "Sorry, the commercial assistant could not answer right now.",
        "error"
      );
    } finally {
      setLoading(false);
      if (input) input.focus();
    }
  }

  form?.addEventListener("submit", function (event) {
    event.preventDefault();

    const question = input?.value || "";
    if (input) input.value = "";

    askAi(question);
  });

  chips.forEach((chip) => {
    chip.addEventListener("click", function () {
      askAi(chip.getAttribute("data-ai-question"));
    });
  });
}

addRoomBtn?.addEventListener("click", function () {
  addRoomRow(root, "offices");
  refreshCalculator();
});

calculateBtn?.addEventListener("click", refreshCalculator);

resetBtn?.addEventListener("click", function () {
  resetCalculator();
  refreshCalculator();
});

bindLiveEvents();
refreshCalculator();
initCommercialAiChat();
  }

  initCommercialMvhr();
})();